(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-hero"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var DESKTOP_QUERY = '(min-width: 768px)';

    var hero = document.querySelector('[data-password-hero]');
    var video = hero ? hero.querySelector('[data-password-hero-video]') : null;
    var bubbles = hero ? hero.querySelectorAll('.sms-bubble') : [];
    var mql = window.matchMedia(DESKTOP_QUERY);

    function currentBreakpoint() {
      return mql.matches ? 'desktop' : 'mobile';
    }

    function playMuted() {
      if (!video) return;
      video.muted = true;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    function updateVisibleBubbles() {
      var breakpoint = currentBreakpoint();
      bubbles.forEach(function (bubble) {
        bubble.hidden = bubble.getAttribute('data-breakpoint') !== breakpoint;
      });
    }

    var rafId = null;
    var lastBreakpoint = currentBreakpoint();
    function scheduleLayout() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = null;
        var breakpoint = currentBreakpoint();
        if (breakpoint !== lastBreakpoint) {
          lastBreakpoint = breakpoint;
          if (video) {
            video.load();
            playMuted();
          }
        }
        updateVisibleBubbles();
      });
    }

    playMuted();
    updateVisibleBubbles();

    window.addEventListener('resize', scheduleLayout);
    window.addEventListener('orientationchange', scheduleLayout);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleLayout);
    }

    bubbles.forEach(function (bubble) {
      bubble.addEventListener('click', function () {
        var bubbleId = bubble.getAttribute('data-sms-bubble');
        document.dispatchEvent(
          new CustomEvent('jumi:sms-bubble-click', { detail: { bubbleId: bubbleId } })
        );
      });
    });

    var earlyAccess = document.getElementById('early-access');
    var earlyAccessClose = document.querySelector('[data-jumi-early-access-close]');

    document.addEventListener('jumi:sms-bubble-click', function () {
      if (earlyAccess) {
        earlyAccess.style.transform = 'translateY(0)';
      }
    });

    if (earlyAccessClose && earlyAccess) {
      earlyAccessClose.addEventListener('click', function () {
        earlyAccess.style.transform = 'translateY(100%)';
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
